import ls from 'store2'
// import Util from './index'
const permissions_all = [
  {
    name: 'global',
    label: '全局权限',
    show: true,
    items: [
      {
        name: 'global',
        label: '全局',
        items: [
          // { name: 'globalSalePrice', label: '查看销售价', descc: '控制显示销售价' },
          { name: 'globalRentPrice', label: '查看租赁价', descc: '控制显示租赁价' },
          { name: 'globalCostPrice', label: '查看成本价', descc: '控制显示产品成本价' },
        ]
      },
    ]
  },
  {
    name: 'dashboard',
    label: '工作台权限',
    show: true,
    items: [
      {
        name: 'dashboardWms',
        label: '现货',
        items: [
          { name: 'dashboardWmsSearchSchedule', label: '查档期', descc: '' },
          { name: 'dashboardWmsSearchUsableBySchedule', label: '查可用产品', descc: '' },
        ]
      },
    ]
  },
  {
    name: 'schedule',
    label: '预约管理',
    show: true,
    items: [
      {
        name: 'schedule',
        label: '预约',
        items: [
          { name: 'scheduleView', label: '预约查看', descc: '预约查看' },
          { name: 'scheduleManage', label: '预约管理', descc: '预约新增、编辑' },
          { name: 'scheduleDelete', label: '预约管理', descc: '预约删除' },
          { name: 'scheduleDeal', label: '预约处理', descc: '预约转化下单、完善客户、完成、放弃、取消、跟踪' },
          { name: 'scheduleSetdDuty', label: '设置预约值班人', descc: '设置预约值班人' }
        ]
      },
    ]
  },
  {
    name: 'rms',
    label: '订单管理',
    show: true,
    items: [
      {
        name: 'rent',
        label: '订单',
        items: [
          { name: 'rentView', label: '订单查看', descc: '查看订单' },
          { name: 'rentManage', label: '订单管理', descc: '订单的新增、编辑，订单收款的新增、编辑、删除' },
          { name: 'rentDelete', label: '订单删除', descc: '订单删除' },
          { name: 'rentStockOut', label: '出库/发货', descc: '订单出库或发货' },
          { name: 'rentStockIn', label: '完成/入库', descc: '订单完成入库' },
          { name: 'rentSpotDelivery', label: '现货交付', descc: '订单现货交付' },
          { name: 'rentPrepare', label: '订单备货', descc: '订单备货' },
          { name: 'rentPrepared', label: '备货完毕', descc: '订单备货完毕' },
          { name: 'rentToProcessing', label: '去生产', descc: '订单去生产' },
          { name: 'rentReceive', label: '收货', descc: '订单收货' },
          { name: 'rentQuality', label: '订单质检', descc: '订单质检通过或者返工' },
          { name: 'receiveAndQuality', label: '收货并质检', descc: '订单收货并质检通过' },
          { name: 'rentCancel', label: '取消', descc: '订单取消' },
          { name: 'rentReturn', label: '退货', descc: '订单退货' },

          { name: 'rentDistributiveOwner', label: '分配拥有人', descc: '给订单分配拥有人' }
        ]
      }
    ]
  },
  {
    name: 'wms',
    label: '现货管理',
    show: true,
    items: [
      {
        name: 'wmsInventory',
        label: '现货',
        items: [
          { name: 'wmsInventoryView', label: '现货查看', descc: '现货查看、出入库单的查看', },
          { name: 'wmsInventoryManage', label: '现货管理', descc: '现货盘点、导入、编辑', },
          { name: 'wmsInventoryDelete', label: '现货删除', descc: '现货删除', },
          { name: 'wmsInventoryStockIn', label: '手动入库', descc: '操作现货入库', },
          { name: 'wmsInventoryStockOut', label: '手动出库', descc: '操作现货出库', },
          { name: 'wmsInventoryDamage', label: '现货报损', descc: '操作现货报损', },
          { name: 'wmsInventoryAllocateIn', label: '申请调入', descc: '操作申请调入', },
          { name: 'wmsInventoryAllocateOut', label: '申请调出', descc: '操作申请调出', },
          { name: 'wmsInventoryClean', label: '生成清洗单', descc: '操作生成清洗单', },

        ]
      },
      {
        name: 'wmsAllocate',
        label: '调拨单',
        items: [
          { name: 'wmsAllocateView', label: '调拨单查看', descc: '查看调拨单', },
          { name: 'wmsAllocateManage', label: '调拨单管理', descc: '调拨单编辑', },
          { name: 'wmsAllocateDelete', label: '调拨单删除', descc: '调拨单删除', },
          { name: 'wmsAllocateVerify', label: '调拨单审核', descc: '调拨单审核同意或拒绝', },
          { name: 'wmsAllocateStockIn', label: '调拨单入库', descc: '调拨单入库', },
        ]
      },
      {
        name: 'wmsDamage',
        label: '报损单',
        items: [
          { name: 'wmsDamageView', label: '报损单查看', descc: '查看报损单', },
          { name: 'wmsDamageManage', label: '报损单管理', descc: '报损单编辑', },
          { name: 'wmsDamageDelete', label: '报损单删除', descc: '报损单删除', },
          { name: 'wmsDamageVerify', label: '报损单审核', descc: '审核报损单', },
        ]
      }
    ]
  },
  {
    name: 'oms',
    label: '客户管理',
    show: true,
    items: [
      {
        name: 'customer',
        label: '客户',
        items: [
          { name: 'customerView', label: '客户查看', descc: '查询客户及查看客户明细' },
          { name: 'customerManage', label: '客户管理', descc: '客户的新增、编辑、跟踪' },
          { name: 'customerDelete', label: '客户删除', descc: '客户的删除' },
          { name: 'customerDistributiveOwner', label: '客户分配拥有人', descc: '分配客户给其他人' }
        ]
      },
    ]
  },
  {
    name: 'pdm',
    label: '产品中心',
    show: true,
    items: [
      {
        name: 'product',
        label: '产品',
        items: [
          { name: 'productView', label: '产品查看', descc: '查询及查看产品' },
          { name: 'productManage', label: '产品管理', descc: '产品的新增、编辑、复制，产品供应商的新增、编辑、删除' },
          { name: 'productDelete', label: '产品删除', descc: '产品的删除' },

        ]
      },
      {
        name: 'service',
        label: '服务',
        items: [
          { name: 'serviceView', label: '服务查看', descc: '查询及查看服务' },
          { name: 'serviceManage', label: '服务管理', descc: '服务的新增、编辑、复制' },
          { name: 'serviceDelete', label: '服务删除', descc: '服务的删除' },

        ]
      },
      {
        name: 'rentPackage',
        label: '套餐',
        items: [
          { name: 'rentPackageView', label: '套餐查看', descc: '查询套餐及查看套餐明细' },
          { name: 'rentPackageManage', label: '套餐管理', descc: '套餐新增、编辑、复制' },
          { name: 'rentPackageDelete', label: '套餐删除', descc: '套餐删除' },

        ]
      },
    ]
  },
  // {
  //   name: 'fnReport',
  //   label: '财务•报表',
  //   show: true,
  //   items: [
  //     {
  //       name: 'settlement',
  //       label: '财务',
  //       items: [

  //       ]
  //     },
  //     {
  //       name: 'report',
  //       label: '报表',
  //       items: [
  //         { name: 'reportView', label: '所有报表的查看权限', descc: null },
  //       ]
  //     },
  //   ]
  // },
]

export default {
  currentTenant() {
    return ls.session('TENANT')
  },
  currentUser() {
    return ls.session('USER')
  },
  edition() {
    if (this.currentTenant() && this.currentTenant().chargeW) {
      return this.currentTenant().chargeW.edition
    }
    return null
  },
  isFreeEdition() {
    if (this.edition() && this.edition() == 'free') {
      return true
    }
    return false
  },
  createOrderFixShopDF() {
    if (this.currentUser() && this.currentUser().admin == true) {
      return false
    }
    if (this.currentTenant() && this.currentTenant().config.createOrderFixShop == true) {
      return true
    }
    return false
  },

  //
  wmsViewShopIds() {
    if (this.currentUser() != null) {
      const permissions = this.currentUser()._permissions || [];
      if (permissions.length != 0) {
        const inventoryViewObj = permissions.find(
          (p) => p.permission == "inventoryView"
        );
        return JSON.parse(
          inventoryViewObj.shops || "'[]'"
        )
      }
      return []
    }
    return []
  },
  wmsManageShopIds() {
    if (this.currentUser() != null) {
      const permissions = this.currentUser()._permissions || [];
      if (permissions.length != 0) {
        const inventoryManageObj = permissions.find(
          (p) => p.permission == "inventoryManage"
        );
        return JSON.parse(
          inventoryManageObj.shops || "'[]'"
        )
      }
      return []
    }
    return []
  },
  //
  actionsJson() {
    if (this.currentUser() != null) {
      const userAuth = JSON.parse(this.currentUser()._actionsJson)
      return userAuth
    }
    return []
  },
  canActions(action) {
    if (this.currentUser() && this.currentUser().admin) {
      return true
    } else {
      return this.actionsJson().includes(action)
    }
  },
  permissions() {
    let permissions = JSON.parse(JSON.stringify(permissions_all))
    return permissions
  },
  sysPermits(sys) {
    const currentSysPermissions = this.permissions().find(p => p.name === sys)
    let permits = []
    if (currentSysPermissions != null) {
      for (const item of currentSysPermissions.items) {
        permits = permits.concat(item.items.map(i => i.name))
      }
    }
    return permits
  },
}

